import { Dashboard, ClientRequestForm } from '@/components';

export const ClientRequestFormPage = () => (
  <Dashboard openLogIn>
    <ClientRequestForm />
  </Dashboard>
);
